<template>
    <div class="dataStatistics">
        <div class="title-box">
            <img class="cion" src="@/assets/home/dateLeft-icon.png"></img>
            <span>{{dataObj.title}}</span>
        </div>
        <div class="dataStatistics-box">
            <div class="znjls_box">
                <span class="numText1" v-for="(item,index) in dataObj.num" :key="index">{{item}}</span>
                <span class="numText2">{{dataObj.unit}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import drawMixin from "@/utils/drawMixin";
    import {
        formatTime
    } from "@/utils/index.js";

    export default {
        // mixins: [drawMixin],
        data() {
            return {
                num: '23223',

            };
        },
        props: {
			dataObj: {
				type: Object,
				default: () => {}
			},
		},
        
        components: {

        },
        created() { 
           
        },
        mounted() {
            // console.log('总收入数据',this.dataObj)

        },
        beforeDestroy() {

        },
        methods: {

        },
    };
</script>

<style lang="scss" scoped>
    /* @import "../../../assets/scss/index.scss"; */

    .dataStatistics {
        /* background-image: url(../../../assets/home/bg-1.png); */
        background: linear-gradient( 180deg, rgba(32,65,116,.3) 0%, rgba(113,161,246,.3) 100%);
        background-size: 100% 100%;
        margin-bottom: 10px;

        .title-box {
            width: 100%;
            height: 42px;
            background-image: url(../../../assets/home/title-box-bg.png);
            background-size: 100% 100%;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            display: flex;
            align-items: center;

            .cion {
                width: 34px;
                height: 35px;
                margin-right: 10px;
            }
        }

        .dataStatistics-box {
            width: 100%;
            padding-top: 10px;

            .znjls_box {
                text-align: center;
                padding-bottom: 15px;
                padding-top: 5px;

                .numText1 {
                    font-family: Source Han Sans SC, Source Han Sans SC;
                    font-weight: 500;
                    font-size: 24px;
                    color: #1CF7FF;

                    background: linear-gradient(180deg, #315A9A 0%, #193E84 43%, #2E5D99 100%);
                    border: 1px solid #6B9CFE;
                    display: inline-flex;
                    width: 30px;
                    height: 40px;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                }

                .numText1:last-child {
                    margin-right: 0;

                }

                .numText2 {
                    font-family: Source Han Sans SC, Source Han Sans SC;
                    font-weight: 500;
                    font-size: 24px;
                    color: #1CF7FF;
                    margin-left: 20px;
                }
            }

        }





    }
</style>